import StatusBadgeM from "@common/components/badge/StatusBadgeM"
import AvatarM from "@common/components/avatar/AvatarM"
import { BadgeM } from "@common/components/badge/BadgeM"
import TouchableRippleM from "@common/components/button/TouchableRippleM"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import { tutorsService } from "@data/services/tutorsService"
import { capitalize } from "@data/utility/Utils"
import { Rating } from "@kolking/react-native-rating"
import { useNavigation } from "@react-navigation/native"
import moment from "moment"
import React, { useState } from "react"
import { Dimensions, View } from "react-native"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import { connect } from "react-redux"
import { EngagementScoreComponent } from "../liveReports/LiveReportsScreen"
import { PaginatedTableM } from "../dataTable/PaginatedTableM"

const LivesHistory = (props) => {
    const { urlParams = {} } = props

    const navigation = useNavigation()

    const [expandedRow, setExpandedRow] = useState(null)

    const requestApiService = tutorsService.getTutorLiveOccurrences

    const handleRowPress = (rowId) => {
        setExpandedRow((prevRowId) => (prevRowId === rowId ? null : rowId))
    }

    const columns = [
        {
            name: "Date",
            style: {
                width: 180,
                marginRight: 20,
                justifyContent: "center",
            },
            clickable: true,
            selector: "date",
            sortable: true,
            cell: (row) => {
                const sessionDate = capitalize(
                    moment(row?.date).format("dddd DD MMMM HH:mm")
                )
                return (
                    <View
                        style={{
                            width: 140,
                        }}
                    >
                        <TouchableRippleM
                            disabled={row?.live_reports?.length === 0}
                            onPress={() => {
                                handleRowPress(row?.id)
                            }}
                        >
                            <View
                                style={{
                                    flexDirection: "row",
                                    alignItems: "center",
                                    justifyContent: "flex-start",
                                    width: 140,
                                }}
                            >
                                {row?.live_reports?.length > 0 && (
                                    <FontAwesome5
                                        name={
                                            expandedRow === row?.id
                                                ? "caret-down"
                                                : "caret-right"
                                        }
                                        color={theme.colors.primary}
                                        solid
                                        size={20}
                                        style={{ marginRight: 5 }}
                                    />
                                )}
                                <TextM
                                    wrap
                                    color={
                                        row?.live_reports?.length > 0
                                            ? theme.colors.primary
                                            : theme.colors.grey
                                    }
                                    fontWeight={
                                        row?.live_reports?.length > 0
                                            ? "Bold"
                                            : "Medium"
                                    }
                                >
                                    {sessionDate}
                                </TextM>
                            </View>
                        </TouchableRippleM>
                    </View>
                )
            },
        },
        {
            name: "Description",
            style: {
                width: 300,
                marginRight: 20,
            },
            selector: "type",
            sortable: true,
            cell: (row) => <TextM wrap>{row?.description ?? "-"}</TextM>,
        },
        {
            name: "Statut",
            style: {
                width: 140,
                marginRight: 20,
            },
            selector: "status",
            sortable: true,
            cell: (row) => {
                const pending =
                    row.status === "pending_review" ||
                    (row.status === "validated" &&
                        (!row?.transferred_at || row?.transfer_amount === 0))

                return (
                    <View
                        style={{
                            alignItems: "flex-start",
                            justifyContent: "flex-start",
                        }}
                    >
                        <View
                            style={{
                                borderWidth: 0,
                                borderColor: theme.colors.white,
                                backgroundColor: pending
                                    ? theme.colors.warning
                                    : row.status === "todo"
                                      ? theme.colors.linkLight
                                      : theme.colors.success,
                                borderRadius: 15,
                                paddingHorizontal: 8,
                                paddingVertical: 4,
                                flexDirection: "row",
                                alignItems: "center",
                            }}
                        >
                            <TextM
                                fontWeight="SemiBold"
                                color={theme.colors.white}
                            >
                                {" "}
                                {pending
                                    ? "En attente"
                                    : row.status === "todo"
                                      ? moment().isAfter(row?.date)
                                          ? "Non fait"
                                          : "À faire"
                                      : "Validé"}
                            </TextM>
                        </View>
                        {row?.transferred_at && (
                            <TextM fontSize={8} fontWeight="Light" wrap>
                                Transféré sur mon solde stripe le{" "}
                                {moment(row?.transferred_at).format(
                                    "DD/MM/YYYY HH:mm"
                                )}
                            </TextM>
                        )}
                    </View>
                )
            },
        },
        {
            name: "Montant",
            style: {
                width: 200,
                marginRight: 20,
            },
            selector: "statistics",
            sortable: false,
            cell: (row) => (
                <View style={{ flexDirection: "column" }}>
                    <TextM>
                        <TextM fontWeight={"SemiBold"}>
                            {row?.transfer_amount
                                ? row?.transfer_amount + " €"
                                : "-"}
                        </TextM>
                    </TextM>
                </View>
            ),
        },
    ]

    const renderExpandedRowContent = (row) => {
        return (
            <View style={{}}>
                {row.live_reports.map((report, index) => (
                    <View
                        key={index}
                        style={{
                            marginBottom: 15,
                            marginLeft: 10,
                        }}
                    >
                        <View
                            style={{
                                flexDirection: "row",
                                alignItems: "center",
                            }}
                        >
                            {/* Student profile column */}
                            <TouchableRippleM
                                style={{
                                    flexDirection: "column",
                                    marginRight: 15,
                                }}
                                onPress={() => {
                                    navigation.push("student-profil", {
                                        studentId: report?.student?.id,
                                        withActions: true,
                                    })
                                }}
                            >
                                <>
                                    <View
                                        style={{
                                            flexDirection: "row",
                                            alignItems: "center",
                                            width: 150,
                                        }}
                                    >
                                        <AvatarM
                                            user={report.student}
                                            size={32}
                                        />
                                        <View style={{ marginLeft: 10 }}>
                                            <TextM
                                                color={theme.colors.primary}
                                                fontWeight={"Medium"}
                                            >
                                                {report?.student?.display_name}
                                            </TextM>
                                            <TextM
                                                color={theme.colors.grey}
                                                fontWeight={"Light"}
                                                fontSize={10}
                                            >
                                                {
                                                    report?.student?.profile
                                                        ?.class
                                                }
                                            </TextM>
                                            {report?.student?.email && (
                                                <TextM
                                                    wrap
                                                    color={theme.colors.grey}
                                                    fontWeight={"Light"}
                                                    fontSize={9}
                                                    style={{ maxWidth: 100 }}
                                                >
                                                    {report?.student?.email}
                                                </TextM>
                                            )}
                                        </View>
                                    </View>
                                    <View
                                        style={{
                                            flexDirection: "row",
                                            alignItems: "center",
                                            gap: 4,
                                            marginTop: 5,
                                            flexWrap: "wrap",
                                        }}
                                    >
                                        {report?.is_student_subscribed_new && (
                                            <BadgeM
                                                style={{
                                                    backgroundColor:
                                                        theme.colors.error,
                                                    color: theme.colors.white,
                                                }}
                                                count={"1er mois"}
                                                size={18}
                                            />
                                        )}
                                        {row?.temporary_student_ids?.includes(
                                            report?.student?.id
                                        ) && (
                                            <StatusBadgeM
                                                icon="redo"
                                                label="Rattrapage"
                                                backgroundColor={
                                                    theme.colors.primaryLighter
                                                }
                                                color={theme.colors.primary}
                                            />
                                        )}
                                    </View>
                                </>
                            </TouchableRippleM>

                            {/* Main content - navigates to live report */}
                            <TouchableRippleM
                                style={{ flex: 1 }}
                                onPress={() => {
                                    navigation.push("r", {
                                        h: report?.hash,
                                    })
                                }}
                            >
                                <View
                                    style={{
                                        flexDirection: "row",
                                        alignItems: "center",
                                    }}
                                >
                                    {/* 1. Engagement score */}
                                    {report?.statistics?.scores?.total_score !==
                                        undefined && (
                                        <TextM
                                            fontSize={16}
                                            color={
                                                report?.statistics?.scores
                                                    ?.total_score < 50
                                                    ? theme.colors.error
                                                    : report?.statistics?.scores
                                                            ?.total_score < 70
                                                      ? theme.colors.warning
                                                      : theme.colors.success
                                            }
                                            fontWeight={"ExtraBold"}
                                            style={{
                                                width: 60,
                                                marginRight: 10,
                                            }}
                                        >
                                            {
                                                report?.statistics?.scores
                                                    ?.total_score
                                            }
                                            <TextM
                                                fontSize={12}
                                                fontWeight={"Bold"}
                                            >
                                                /100
                                            </TextM>
                                        </TextM>
                                    )}

                                    {/* 2. Engagement détails (sub-scores bar) */}
                                    <EngagementScoreComponent
                                        scores={report?.statistics?.scores}
                                        autoWidth
                                        showTotalScore={false}
                                        style={{
                                            width: 550,
                                            marginLeft: 0,
                                            marginRight: 10,
                                        }}
                                    />

                                    {/* 3. Note tuteur + tags */}
                                    <View
                                        style={{
                                            flexDirection: "column",
                                            alignItems: "flex-start",
                                            width: 120,
                                            marginRight: 10,
                                        }}
                                    >
                                        <TextM
                                            fontSize={9}
                                            fontWeight="Medium"
                                            color={theme.colors.grey}
                                        >
                                            Note tuteur
                                        </TextM>
                                        <Rating
                                            maxRating={5}
                                            rating={report?.tutor_rating ?? 0}
                                            size={12}
                                            fillColor={theme.colors.accent}
                                            disabled
                                        />
                                        {report?.tutor_tags?.length > 0 && (
                                            <TextM
                                                wrap
                                                fontSize={10}
                                                style={{ marginTop: 2 }}
                                            >
                                                {report.tutor_tags
                                                    .map((tag) =>
                                                        tag.emoji
                                                            ? `${tag.emoji} ${tag.label}`
                                                            : tag.label
                                                    )
                                                    .reduce((acc, tag, i) => {
                                                        const lineIndex =
                                                            Math.floor(i / 2)
                                                        if (!acc[lineIndex])
                                                            acc[lineIndex] = []
                                                        acc[lineIndex].push(tag)
                                                        return acc
                                                    }, [])
                                                    .map((line) =>
                                                        line.join(", ")
                                                    )
                                                    .join("\n")}
                                            </TextM>
                                        )}
                                    </View>

                                    {/* 4. Commentaire tuteur */}
                                    <View
                                        style={{ width: 250, marginRight: 10 }}
                                    >
                                        <TextM wrap fontSize={12}>
                                            {report?.tutor_comment?.length > 0
                                                ? report?.tutor_comment
                                                : "-"}
                                        </TextM>
                                    </View>
                                </View>
                            </TouchableRippleM>
                        </View>
                    </View>
                ))}
            </View>
        )
    }

    return (
        <View
            style={{
                alignSelf: "center",
                alignItems: "center",
                width: Dimensions.get("window").width,
                flex: 1,
            }}
        >
            <PaginatedTableM
                data={props.tutorLiveOccurrences}
                flatListRef={null}
                columns={columns}
                headerHeight={60}
                requestService={requestApiService}
                urlParams={urlParams}
                expandedRow={expandedRow}
                expandedRowContent={renderExpandedRowContent}
            />
        </View>
    )
}
const mapStateToProps = (state) => {
    return {
        tutorLiveOccurrences: state.data?.tutors?.liveOccurrences,
    }
}

export default connect(mapStateToProps)(LivesHistory)
